import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeName = 'dark' | 'light';

export interface SettingsState {
  theme: ThemeName;
  /** 'local', 'UTC' or an IANA zone. */
  timeZone: string;
  /** Faint symbol + interval behind the candles. */
  watermark: boolean;
  setTheme: (theme: ThemeName) => void;
  toggleTheme: () => void;
  setTimeZone: (tz: string) => void;
  setWatermark: (on: boolean) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      timeZone: 'local',
      watermark: true,
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
      setTimeZone: (timeZone) => set({ timeZone }),
      setWatermark: (watermark) => set({ watermark }),
    }),
    { name: 'ch:settings' },
  ),
);

/** Keep the `dark` class on <html> in step with the theme setting. */
export function applyTheme(theme: ThemeName): void {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  const meta = document.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', theme === 'dark' ? '#0b1011' : '#ffffff');
}

export const TIME_ZONES: Array<{ id: string; label: string }> = [
  { id: 'local', label: 'Local time' },
  { id: 'UTC', label: 'UTC' },
  { id: 'Europe/London', label: 'London' },
  { id: 'Europe/Amsterdam', label: 'Amsterdam' },
  { id: 'Europe/Istanbul', label: 'Istanbul' },
  { id: 'Asia/Dubai', label: 'Dubai' },
  { id: 'Asia/Kolkata', label: 'Mumbai' },
  { id: 'Asia/Singapore', label: 'Singapore' },
  { id: 'Asia/Hong_Kong', label: 'Hong Kong' },
  { id: 'Asia/Tokyo', label: 'Tokyo' },
  { id: 'Australia/Sydney', label: 'Sydney' },
  { id: 'America/New_York', label: 'New York' },
  { id: 'America/Chicago', label: 'Chicago' },
  { id: 'America/Los_Angeles', label: 'Los Angeles' },
  { id: 'America/Sao_Paulo', label: 'São Paulo' },
];
